import { ConfigurationType } from 'civil-status/constants/configuration-type';

export const withIsSignatoryCheck = (configuration: string): boolean => {
  return (
    configuration === ConfigurationType.BASEFOPFI ||
    configuration === ConfigurationType.CONIOPFI ||
    configuration === ConfigurationType.BASEOPFI ||
    configuration === ConfigurationType.BASE02OPFI ||
    configuration === ConfigurationType.RICH_UCOPF ||
    configuration === ConfigurationType.BASEAVV3 ||
    configuration === ConfigurationType.BASESCATTO ||
    configuration === ConfigurationType.INTCIT4
  );
};
